import { C } from '../../theme';
import { SousTitreSection } from './base';
import { api } from '../../api/routes';
import { useDonnees } from '../../api/useDonnees';

const nombre = (n: number): string => n.toLocaleString('fr-FR');

/** « 2026-10-01 » -> « 1er octobre ». Le jour est toujours le premier du mois. */
function premierDuMois(jour: string): string {
  const mois = new Intl.DateTimeFormat('fr-FR', { month: 'long', timeZone: 'UTC' }).format(
    new Date(`${jour}T00:00:00Z`),
  );
  return `1er ${mois}`;
}

/**
 * Ou en est le foyer ce mois-ci : son plan, et ce qu'il a utilise.
 *
 * En LECTURE seule, et pour tout le foyer. Changer de plan ne se fait pas ici : ce
 * serait une commande qui ne commande rien tant que la demande de changement n'existe
 * pas cote serveur.
 *
 * Si le decompte ne repond pas, le bloc ne s'affiche pas : il n'est qu'une information,
 * et un compteur absent vaut mieux qu'un ecran de Reglages en erreur.
 */
export function PlanDuFoyer({ version }: { version: number }) {
  const etat = useDonnees((signal) => api.plan(signal), version);
  const usage = etat.donnees;
  if (usage === null || usage === undefined) return null;

  const { plan, utilisees, restantes, retourLe } = usage;
  // Un foyer qui change de plan en cours de mois peut avoir utilise plus que sa nouvelle
  // limite : la jauge s'arrete a son bord.
  const comptees = Math.min(utilisees, plan.demandesParMois);
  const part = plan.demandesParMois === 0 ? 100 : Math.round((comptees / plan.demandesParMois) * 100);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <SousTitreSection>Ce mois-ci</SousTitreSection>
      <div
        style={{
          background: C.carte,
          border: `1px solid ${C.bordure}`,
          borderRadius: 14,
          padding: '13px 16px',
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: C.encre }}>Plan {plan.nom}</div>
          <div style={{ fontSize: 13, color: C.secondaire }}>
            {nombre(utilisees)} demande{utilisees > 1 ? 's' : ''} sur {nombre(plan.demandesParMois)}
          </div>
        </div>
        <div
          role="progressbar"
          aria-label="Demandes utilisées ce mois-ci"
          aria-valuemin={0}
          aria-valuemax={plan.demandesParMois}
          aria-valuenow={comptees}
          style={{ height: 6, borderRadius: 3, background: C.rail, overflow: 'hidden' }}
        >
          <div style={{ width: `${part}%`, height: 6, borderRadius: 3, background: C.accent }} />
        </div>
        {restantes === 0 ? (
          <div style={{ fontSize: 13, color: C.encre, lineHeight: 1.5 }}>
            Les demandes du mois sont utilisées. Elles reviennent le {premierDuMois(retourLe)}.
          </div>
        ) : null}
        <div style={{ fontSize: 12, color: C.secondaire, lineHeight: 1.5 }}>
          Seules les demandes à l’intelligence de Colette sont comptées : organiser, répondre à une
          question, préparer la liste de courses. Tout ce que tu fais à la main reste sans limite.
        </div>
      </div>
    </div>
  );
}
